import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createClientLogo,
  getAllClientLogos,
  getClientLogoByID,
  ClientLogoImageUpload,
  updateClientLogo,
} from "./services/clientLogo.services";
import { clearClientLogoDetails } from "./clientLogoSlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateClientLogo: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const ClientLogoID = location.state?.ClientLogoID;
  const ClientLogoID = useAppSelector((state) => state.muidrawer.data);
  const ClientLogoDetail = useAppSelector(
    (state) => state.clientLogo.ClientLogoDetail
  );
  const loading = useAppSelector((state) => state.clientLogo.formLoading);
  const [formKey, setFormKey] = React.useState(1);

  useEffect(() => {
    if (ClientLogoID) {
      dispatch(getClientLogoByID(ClientLogoID));
    }
    return () => {
      dispatch(clearClientLogoDetails());
    };
  }, [ClientLogoID]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [ClientLogoDetail]);

  const handleSubmit = async (values: any) => {
    const formData = {
      ClientName: values?.ClientName ? values?.ClientName : "",
      IsActive: values?.IsActive === 1,
    };
    const ImageData = new FormData();
    const Image =
      values?.Image &&
      typeof values?.Image !== "string" &&
      Array.isArray(values?.Image) &&
      values?.Image?.length > 0
        ? values.Image[0].getRawFile()
        : "";

    try {
      if (ClientLogoID) {
        const editPayload = {
          ...formData,
          ID: ClientLogoID,
        };

        const response = await dispatch(updateClientLogo(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0
          ) {
            ImageData.append("Image", Image);
            ImageData.append("ID", ClientLogoID);
            await dispatch(ClientLogoImageUpload(ImageData));
          }
          dispatch(getAllClientLogos());
          dispatch(clearClientLogoDetails());
        }
      } else {
        const response = await dispatch(createClientLogo(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0 &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("Image", Image);

            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(ClientLogoImageUpload(ImageData));
          }
          dispatch(getAllClientLogos());
          dispatch(clearClientLogoDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={ClientLogoDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {ClientLogoID ? "Update Client" : "Create Client"}
                  </Typography.h4>
                  <Button
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </Button>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="ClientName"
                    label="Client Name"
                    placeholder="Client Name"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    justifyContent="start"
                    name="Image"
                    label="Client Logo"
                    type="file"
                    accept="image/*"
                    alternateName="Client Logo"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={ClientLogoID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateClientLogo;
